import { AppCta } from "@components/home/AppCta";
import { Estimator } from "@components/home/Estimator";
import { Faq } from "@components/home/Faq";
import { FlexStrip } from "@components/home/FlexStrip";
import { Hero } from "@components/home/Hero";
import { Products } from "@components/home/Products";
import { Trust } from "@components/home/Trust";
import { Why } from "@components/home/Why";
import { Page } from "@components/layout/Page";
import { Steps } from "@components/shared/Steps";
import { UNLOCK } from "@/lib/site";
import { useTranslations } from "@services/strings";

const HomePage = () => {
  const { t } = useTranslations();
  const approvalDays = UNLOCK.approvalDays;

  return (
    <Page
      title={t("site.home.meta.title")}
      description={t("site.home.meta.description", { approvalDays })}
    >
      <Hero />
      <Products />
      <FlexStrip
        placement="home"
        title={t("site.home.flexStrip.title")}
        body={t("site.home.flexStrip.body")}
        cta={t("site.home.flexStrip.cta")}
      />
      <Steps
        title={t("site.home.how.title")}
        steps={[
          {
            title: t("site.home.how.steps.one.title"),
            body: t("site.home.how.steps.one.body"),
          },
          {
            title: t("site.home.how.steps.two.title"),
            body: t("site.home.how.steps.two.body"),
          },
          {
            title: t("site.home.how.steps.three.title"),
            body: t("site.home.how.steps.three.body", { approvalDays }),
          },
        ]}
      />
      <Estimator tone="mist" />
      <Why />
      <Trust />
      <Faq
        title={t("site.home.faq.title")}
        items={(
          [
            "ownership",
            "eligible",
            "outside",
            "installments",
            "cost",
            "speed",
            "safety",
          ] as const
        ).map((id) => ({
          id,
          question: t(`site.home.faq.items.${id}.q`),
          answer: t(`site.home.faq.items.${id}.a`, { approvalDays }),
        }))}
      />
      <AppCta
        placement="home-cta"
        title={t("site.home.cta.title")}
        body={t("site.home.cta.body")}
      />
    </Page>
  );
};

export default HomePage;
